export default __webpack_public_path__ + "static/media/brands_az.b8831f32.jpg";